import {get} from './base.service'
import {post} from './base.service'
export default {
    // 查询我的挂号列表 默认查询三个月
    getMyRegisterList(params) {
        //默认查过去3个月
        const today = new Date()
        params.endDate = params.endDate || today.format('yyyy-MM-dd')
        today.setMonth(today.getMonth() - 3)
        params.startDate = params.startDate || today.format('yyyy-MM-dd')
        return get('/app/register/list/{cardType}/{cardNo}/{startDate}/{endDate}', {
            params: params,
        }).then(res => {
            if (res.resultCode === '1') {
                return res.data
            }
            return res.resultMsg
        })
    },
    // 查询我的缴费列表 默认查询三个月
    getMyPayList(params) {
        const today = new Date()
        params.endDate = params.endDate || today.format('yyyy-MM-dd')
        today.setMonth(today.getMonth() - 3)
        params.startDate = params.startDate || today.format('yyyy-MM-dd')
        return get('/app/clinic/paid/list/{cardType}/{cardNo}/{startDate}/{endDate}', {
            params: params,
        }).then(res => {
            if (res.resultCode === '1') {
                return res.data
            }
            return res.resultMsg
        })
    },
    // 查询门诊缴费列表
    getClinicList(params) {
        return get('/app/clinic/unpay/list/{cardType}/{cardNo}', {
            params: params,
        })
    },
    // 查询检验报告列表
    getLabList(params) {
        return get('/app/report/lab/list/{cardType}/{cardNo}/{startDate}/{endDate}', {
            params: params,
        })
    },
    // 查询检查报告列表
    getExamList(params) {
        return get('/app/report/exam/list/{cardType}/{cardNo}/{startDate}/{endDate}', {
            params: params,
        })
    },
    // 查询住院患者信息
    getInpatientInfo(params) {
        return get('/app/inpatient/info?cardType={cardType}&cardNo={cardNo}', {
            params: params,
        })
    },
    // 查询住院充值记录 默认查询三个月
    getRechargeList(params) {
        const today = new Date()
        params.endDate = params.endDate || today.format('yyyy-MM-dd')
        today.setMonth(today.getMonth() - 3)
        params.startDate = params.startDate || today.format('yyyy-MM-dd')
        return get('/app/inpatient/rechargeList?inPatientNo={inPatientNo}&startDate={startDate}&endDate={endDate}', {
            params: params,
        })
    },
    // 确认住院预缴金充值
    submitRecharge(params) {
        return post('/app/inpatient/submitRecharge', params)
    },
    //查询排队信息
    getWaitInfo(params) {
        return get(`/app/clinic/queueInfo?cardType=${params.cardType}&cardNo=${params.cardNo}&type=${params.type}`, params)
    },
    //查询电子处方信息
    getReceipe(params) {
        return post('/app/clinic/recipeRecord', params)
    },
    //查询住院清单列表
    getCostList(params) {
        return post('/app/inpatient/bill', params)
    },
    //查询住院清单明细
    getCostDetail(params) {
        return get('/app/inpatient/billDetail', params)
    }
}



// WEBPACK FOOTER //
// ./src/service/queryFunList.service.js